/**
 * Los documentos fiscales que el contador entrega a un emisor.
 *
 * La clave es la bandera del paquete que los habilita —la misma que devuelve
 * GET /package-capabilities—, y `route` el tramo de URL del API. Añadir un tipo
 * nuevo es añadir una entrada aquí.
 */
export const FISCAL_DOCUMENTS = {
  fiscalCertificate: {
    route: "certificateTax",
    titleKey: "ui.fiscalCertificate",
    fileName: "constancia.pdf",
    icon: "bi-file-earmark-text",
  },
  complianceOpinion: {
    route: "complianceOpinion",
    titleKey: "ui.complianceOpinion",
    fileName: "opinion-32d.pdf",
    icon: "bi-shield-check",
  },
};

/**
 * El semáforo del 32/D.
 *
 * «Sin determinar» es gris y manda a preguntarle al contador: es lo que queda
 * cuando el PDF no se deja leer o no dice en qué sentido va. Nunca se pinta
 * verde por omisión.
 */
export const COMPLIANCE_TONES = {
  positivo: { variant: "success", icon: "bi-check-circle-fill" },
  negativo: { variant: "danger", icon: "bi-x-circle-fill" },
  sin_determinar: { variant: "secondary", icon: "bi-question-circle-fill" },
};

export const complianceTone = (status) =>
  COMPLIANCE_TONES[status] ?? COMPLIANCE_TONES.sin_determinar;
